import React, { useEffect, useState } from "react";
import { API_ciudadanos } from "../../config/apiConfig";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { toast } from "react-toastify";
import {
  FaBriefcase,
  FaBuilding,
  FaLocationDot,
  FaPenToSquare,
  FaCheck,
  FaX,
  FaCirclePlus,
  FaRegTrashCan,
} from "react-icons/fa6";
import "../../pages/user/css/Curriculum.css";

const Experiencia = ({ usuario }) => {
  const [experiencias, setExperiencias] = useState([]);

  // Estados de edición
  const [editIndex, setEditIndex] = useState(null);
  const [tempExperiencia, setTempExperiencia] = useState({});
  const [isNewItem, setIsNewItem] = useState(false);

  // Opciones para el tipo de contrato y sector
  const opcionesContrato = ["Indefinido", "Temporal", "Prácticas"];
const opcionesSector = [
  "Actividades Físicas y Deportivas",
  "Actividades y Competencias Transversales",
  "Administración y Gestión",
  "Agraria",
  "Artes Gráficas",
  "Artes y Artesanías",
  "Comercio y Marketing",
  "Edificación y Obra Civil",
  "Electricidad y Electrónica",
  "Energía y Agua",
  "Fabricación Mecánica",
  "Hostelería y Turismo",
  "Imagen Personal",
  "Imagen y Sonido",
  "Industrias Alimentarias",
  "Industrias Extractivas",
  "Informática y Comunicaciones",
  "Instalación y Mantenimiento",
  "Inteligencia Artificial y Data",
  "Madera, Mueble y Corcho",
  "Marítimo-Pesquera",
  "Química",
  "Sanidad",
  "Seguridad y Medio Ambiente",
  "Servicios Socioculturales y a la Comunidad",
  "Textil, Confección y Piel",
  "Transporte y Mantenimiento de Vehículos",
  "Vidrio y Cerámica"
];

  useEffect(() => {
    if (usuario?.userId) {
      fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`)
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data.Experience) && data.Experience.length > 0) {
            const mapped = data.Experience.map((item, index) => ({
              id: String(index + 1),
              cargo: item.position || "",
              empresa: item.company || "",
              ubicacion: item.companyAddress || "",
              sector: item.sector || "Hostelería",
              contrato: item.contractType || "Indefinido",
              fechaInicio: item.startDate?.split("T")[0] || "",
              fechaFin: item.endDate?.split("T")[0] || "",
              tareas: item.responsibilities || "",
              actualidad: item.isOngoing || false,
            }));
            setExperiencias(mapped);
          } else {
            // Si no hay experiencia, inicializar con array vacío
            setExperiencias([]);
          }
        })
        .catch((err) => console.error("Error al cargar formación:", err));
    }
  }, [usuario]);

  const handleSaveEdit = async () => {
    const updatedExperiencias = [...experiencias];
    updatedExperiencias[editIndex] = tempExperiencia;
    setExperiencias(updatedExperiencias);
    setEditIndex(null);
    setIsNewItem(false);

    // Preparamos los datos para enviar al backend
    const payload = {
      Experience: updatedExperiencias.map((exp) => ({
        position: exp.cargo,
        company: exp.empresa,
        companyAddress: exp.ubicacion,
        contractType: exp.contrato,
        responsibilities: exp.tareas,
        sector: exp.sector,
        startDate: exp.fechaInicio ? new Date(exp.fechaInicio) : null,
        endDate: exp.actualidad
          ? null
          : exp.fechaFin
          ? new Date(exp.fechaFin)
          : null,
        isOngoing: exp.actualidad,
      })),
    };

    try {
      const token = localStorage.getItem("authToken");
      const res = await fetch(
        `${API_ciudadanos}/${usuario.userId}/curriculum`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Error al actualizar experiencia");

      toast.success("Experiencia actualizada correctamente");
    } catch (error) {
      console.error("❌ Error al guardar experiencia:", error);
      toast.error("No se pudo guardar la experiencia");
    }
  };

  const formatFecha = (fechaISO) => {
    if (!fechaISO) return "";
    const [a, m, d] = fechaISO.split("T")[0].split("-");
    return `${d}/${m}/${a}`;
  };

  // Habilitar edición
  const handleEdit = (index) => {
    setEditIndex(index);
    setTempExperiencia({ ...experiencias[index] });
    setIsNewItem(false);
  };

  // Opcion Actualidad, en vez de Fecha Fin
  const handleCheckboxChange = () => {
    setTempExperiencia((prev) => ({
      ...prev,
      actualidad: !prev.actualidad,
      fechaFin: !prev.actualidad ? "Sigo trabajando aquí" : "",
    }));
  };

  // Cancelar edición
  const handleCancelEdit = () => {
    if (isNewItem) {
      // Si es un elemento nuevo, eliminarlo
      setExperiencias(experiencias.slice(1));
    }
    setEditIndex(null);
    setIsNewItem(false);
  };

  // Eliminar experiencia
  const handleDelete = async (index) => {
    const updatedExperiencias = experiencias.filter((_, i) => i !== index);
    setExperiencias(updatedExperiencias);

    // Preparamos los datos para enviar al backend
    const payload = {
      Experience: updatedExperiencias.map((exp) => ({
        position: exp.cargo,
        company: exp.empresa,
        companyAddress: exp.ubicacion,
        contractType: exp.contrato,
        responsibilities: exp.tareas,
        sector: exp.sector,
        startDate: exp.fechaInicio ? new Date(exp.fechaInicio) : null,
        endDate: exp.actualidad
          ? null
          : exp.fechaFin
          ? new Date(exp.fechaFin)
          : null,
        isOngoing: exp.actualidad,
      })),
    };

    try {
      const token = localStorage.getItem("authToken");
      const res = await fetch(
        `${API_ciudadanos}/${usuario.userId}/curriculum`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Error al eliminar experiencia");

      toast.success("Experiencia eliminada correctamente");
    } catch (error) {
      console.error("❌ Error al eliminar experiencia:", error);
      toast.error("No se pudo eliminar la experiencia");
      // Revertir el cambio en caso de error
      setExperiencias(experiencias);
    }
  };

  // Añadir nueva experiencia
  const handleAddExperiencia = () => {
    const nuevaExperiencia = {
      id: `${experiencias.length + 1}`,
      cargo: "",
      sector: "Hostelería",
      contrato: "Indefinido",
      fechaInicio: "",
      fechaFin: "",
      empresa: "",
      ubicacion: "",
      tareas: "",
      actualidad: false,
    };
    setExperiencias([nuevaExperiencia, ...experiencias]);
    // Activar modo edición para el nuevo elemento
    setEditIndex(0);
    setTempExperiencia({ ...nuevaExperiencia });
    setIsNewItem(true);
  };

  // Función para manejar el drag & drop
  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const reorderedExperiencias = [...experiencias];
    const [movedItem] = reorderedExperiencias.splice(result.source.index, 1);
    reorderedExperiencias.splice(result.destination.index, 0, movedItem);
    setExperiencias(reorderedExperiencias);

    // Preparamos los datos para enviar al backend
    const payload = {
      Experience: reorderedExperiencias.map((exp) => ({
        position: exp.cargo,
        company: exp.empresa,
        companyAddress: exp.ubicacion,
        contractType: exp.contrato,
        responsibilities: exp.tareas,
        sector: exp.sector,
        startDate: exp.fechaInicio ? new Date(exp.fechaInicio) : null,
        endDate: exp.actualidad
          ? null
          : exp.fechaFin
          ? new Date(exp.fechaFin)
          : null,
        isOngoing: exp.actualidad,
      })),
    };

    try {
      const token = localStorage.getItem("authToken");
      const res = await fetch(
        `${API_ciudadanos}/${usuario.userId}/curriculum`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Error al reordenar experiencias");

      toast.success("Orden de experiencias actualizado");
    } catch (error) {
      console.error("❌ Error al reordenar experiencias:", error);
      toast.error("No se pudo actualizar el orden de las experiencias");
      // Revertir el cambio en caso de error
      setExperiencias(experiencias);
    }
  };

  return (
    <div className="ocupaciones caja-verde">
      <div className="titulo-editar between blanco fondo-verde">
        <h2 className="align-center mayusculas">
          <FaBriefcase />
          Experiencia laboral
        </h2>
        <button
          aria-label="Añadir experiencia"
          className="fondo-verde blanco no-border"
          onClick={handleAddExperiencia}
        >
          <FaCirclePlus />
        </button>
      </div>

      {/* Drag & Drop Context */}
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="experiencias">
          {(provided) => (
            <div
              className="contenido column"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {experiencias.map((exp, index) => (
                <Draggable key={exp.id} draggableId={exp.id} index={index}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className="experiencia draggable"
                    >
                      <div className="between cada-experiencia">
                        <div className="column mb-10">
                          {/* Cargo */}
                          <h3
                            className={
                              !exp.cargo || exp.cargo === "Puesto de trabajo"
                                ? "texto-defecto"
                                : ""
                            }
                          >
                            {editIndex === index ? (
                              <input
                                aria-label="Puesto laboral"
                                className="w-400"
                                type="text"
                                placeholder="Puesto de trabajo"
                                value={tempExperiencia.cargo}
                                onChange={(e) =>
                                  setTempExperiencia({
                                    ...tempExperiencia,
                                    cargo: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              exp.cargo || "Puesto de trabajo"
                            )}
                          </h3>
                          {/* Sector */}
                          {editIndex === index ? (
                            <select
                              aria-label="Sector laboral"
                              value={tempExperiencia.sector}
                              onChange={(e) =>
                                setTempExperiencia({
                                  ...tempExperiencia,
                                  sector: e.target.value,
                                })
                              }
                            >
                              {opcionesSector.map((opcion) => (
                                <option key={opcion} value={opcion}>
                                  {opcion}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <h4
                              className={`mb-10 ${
                                !exp.sector || exp.sector === "Sector"
                                  ? "texto-defecto"
                                  : ""
                              }`}
                            >
                              {exp.sector || "Sector"}
                            </h4>
                          )}
                        </div>
                        <div className="acciones acciones-experiencia flex">
                          {editIndex === index ? (
                            <>
                              <button
                                aria-label="Guardar cambios"
                                className="check fondo-blanco verde no-border"
                                onClick={handleSaveEdit}
                              >
                                <FaCheck />
                              </button>
                              <button
                                aria-label="Cancelar cambios"
                                className="check fondo-blanco rojo no-border"
                                onClick={handleCancelEdit}
                              >
                                <FaX />
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                aria-label="Editar esta experiencia"
                                className="experiencia-edicion no-border editar-experiencia"
                                onClick={() => handleEdit(index)}
                              >
                                <FaPenToSquare />
                              </button>
                              <button
                                aria-label="Eliminar esta experiencia"
                                className="experiencia-edicion no-border eliminar-experiencia"
                                onClick={() => handleDelete(index)}
                              >
                                <FaRegTrashCan />
                              </button>
                            </>
                          )}
                        </div>
                      </div>

                      <div className="datos between w-100">
                        <div className="column gap-5">
                          {/* Tipo de contrato con Select en modo edición */}
                          {editIndex === index ? (
                            <select
                              aria-label="Tipo de contrato"
                              value={tempExperiencia.contrato}
                              onChange={(e) =>
                                setTempExperiencia({
                                  ...tempExperiencia,
                                  contrato: e.target.value,
                                })
                              }
                            >
                              {opcionesContrato.map((opcion) => (
                                <option key={opcion} value={opcion}>
                                  {opcion}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <p
                              className={
                                !exp.contrato ||
                                exp.contrato === "Tipo de contrato"
                                  ? "texto-defecto"
                                  : ""
                              }
                            >
                              {exp.contrato || "Tipo de contrato"}
                            </p>
                          )}

                          {/* Fecha de inicio y fin */}
                          {editIndex === index ? (
                            <p className="align-center gap-10">
                              <input
                                aria-label="Fecha de inicio"
                                type="date"
                                value={tempExperiencia.fechaInicio}
                                onChange={(e) =>
                                  setTempExperiencia({
                                    ...tempExperiencia,
                                    fechaInicio: e.target.value,
                                  })
                                }
                              />
                              {" - "}
                              <input
                                aria-label="Fecha fin"
                                type="date"
                                value={tempExperiencia.fechaFin}
                                onChange={(e) =>
                                  setTempExperiencia({
                                    ...tempExperiencia,
                                    fechaFin: e.target.value,
                                  })
                                }
                                disabled={tempExperiencia.actualidad}
                              />
                              <label className="align-center gap-5">
                                <input
                                  aria-label="Sigo trabajando aquí"
                                  type="checkbox"
                                  checked={tempExperiencia.actualidad}
                                  onChange={handleCheckboxChange}
                                />{" "}
                                Actualidad
                              </label>
                            </p>
                          ) : (
                            `${formatFecha(exp.fechaInicio)} - ${
                              exp.actualidad
                                ? "Sigo trabajando aquí"
                                : formatFecha(exp.fechaFin)
                            }`
                          )}
                        </div>

                        <div className="column gap-5">
                          <p
                            className={`align-center end ${
                              !exp.empresa || exp.empresa === "Empresa"
                                ? "texto-defecto"
                                : ""
                            }`}
                          >
                            {editIndex === index ? (
                              <input
                                aria-label="Nombre de la empresa"
                                className="w-250"
                                type="text"
                                placeholder="Nombre de la empresa"
                                value={tempExperiencia.empresa}
                                onChange={(e) =>
                                  setTempExperiencia({
                                    ...tempExperiencia,
                                    empresa: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              exp.empresa || "Empresa"
                            )}
                            <FaBuilding />
                          </p>
                          <p
                            className={`align-center end ${
                              !exp.ubicacion || exp.ubicacion === "Dirección"
                                ? "texto-defecto"
                                : ""
                            }`}
                          >
                            {editIndex === index ? (
                              <input
                                aria-label="Dirección de la empresa"
                                className="w-250"
                                type="text"
                                placeholder="Dirección de la empresa"
                                value={tempExperiencia.ubicacion}
                                onChange={(e) =>
                                  setTempExperiencia({
                                    ...tempExperiencia,
                                    ubicacion: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              exp.ubicacion || "Dirección"
                            )}
                            <FaLocationDot />
                          </p>
                        </div>
                      </div>

                      {/* Breve descripción de tareas en un solo textarea */}
                      <div className="tareas">
                        {editIndex === index ? (
                          <textarea
                            aria-label="Breve descripción de las tareas realizadas"
                            className="w-100"
                            placeholder="Descripción de las tareas realizadas"
                            value={tempExperiencia.tareas}
                            onChange={(e) =>
                              setTempExperiencia({
                                ...tempExperiencia,
                                tareas: e.target.value,
                              })
                            }
                          />
                        ) : (
                          <p
                            className={
                              !exp.tareas || exp.tareas === "Tareas realizadas"
                                ? "texto-defecto"
                                : ""
                            }
                            style={{ whiteSpace: "pre-line" }}
                          >
                            {exp.tareas || "Tareas realizadas"}
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default Experiencia;
